export default __webpack_public_path__ + "static/media/not.6ea7f4d0.svg";